export const FUTURE_DATE_ERROR = 'admin.error.futureDate';
export const INSUFFICIENT_STOCK_ERROR = 'admin.error.insufficientStock';
export const RECALCULATION_FAILED = 'admin.error.recalculationFailed';
export const SUCCESSFULLY_REMOVED = 'admin.success.removed';
export const SUCCESSFULLY_MODIFIED = 'admin.success.modified';
export const SUCCESSFULLY_SAVED = 'admin.success.saved';
